@file:OptIn(InternalResourceApi::class)

package dev.wyns.ventrova.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/dev.wyns.ventrova.resources/"

@delegate:ResourceContentHash(1_250_529_726)
internal val Res.font.inter_bold: FontResource by lazy {
      FontResource("font:inter_bold", setOf(
        ResourceItem(setOf(), "${MD}font/inter_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-583_124_146)
internal val Res.font.inter_medium: FontResource by lazy {
      FontResource("font:inter_medium", setOf(
        ResourceItem(setOf(), "${MD}font/inter_medium.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_319_043_519)
internal val Res.font.inter_regular: FontResource by lazy {
      FontResource("font:inter_regular", setOf(
        ResourceItem(setOf(), "${MD}font/inter_regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(555_351_851)
internal val Res.font.inter_semibold: FontResource by lazy {
      FontResource("font:inter_semibold", setOf(
        ResourceItem(setOf(), "${MD}font/inter_semibold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-554_088_495)
internal val Res.font.roboto_bold: FontResource by lazy {
      FontResource("font:roboto_bold", setOf(
        ResourceItem(setOf(), "${MD}font/roboto_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_562_141_973)
internal val Res.font.roboto_medium: FontResource by lazy {
      FontResource("font:roboto_medium", setOf(
        ResourceItem(setOf(), "${MD}font/roboto_medium.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(654_465_483)
internal val Res.font.roboto_regular: FontResource by lazy {
      FontResource("font:roboto_regular", setOf(
        ResourceItem(setOf(), "${MD}font/roboto_regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(830_478_853)
internal val Res.font.roboto_semibold: FontResource by lazy {
      FontResource("font:roboto_semibold", setOf(
        ResourceItem(setOf(), "${MD}font/roboto_semibold.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectJsMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("inter_bold", Res.font.inter_bold)
  map.put("inter_medium", Res.font.inter_medium)
  map.put("inter_regular", Res.font.inter_regular)
  map.put("inter_semibold", Res.font.inter_semibold)
  map.put("roboto_bold", Res.font.roboto_bold)
  map.put("roboto_medium", Res.font.roboto_medium)
  map.put("roboto_regular", Res.font.roboto_regular)
  map.put("roboto_semibold", Res.font.roboto_semibold)
}
